export default {
  freeTimesLimitTitle: '무료 평가판은 오늘 소진되었습니다.',
  fileSizeLimitTitle: '무료 버전에서는 파일 크기가 20MB를 초과할 수 없습니다.',
  total: '총가격',
  enterCode: '코드 입력',
  signUpToPurchaseBtn: '등록하고 구입하기',
  goPurchseBtn: '바로 구입',
  saveTips: '최대 {{num}}% 절약',
  discount: '할인',
  montly: '월간',
  yearly: '연간',
  weekly: '주간',
  week: '주',
  priceWeek: '₩13,399',
  priceMonth: '₩10,099',
  priceYearly: '₩5,099',
  billMonth: '₩40,199월별 청구액',
  billYear: '₩241,199월별 청구액',
  AlreadySubscribe: '이미 구독하셨나요?',
  vipTips1: '파일 크기 제한 없음',
  vipTips2: '처리하는 파일 수에 제한 없음',
  vipTips3: '제한 없이 이미지 배경 변경',
  vipTips4: '모든 무료 도구 및 프리미엄 기능에 액세스',
  purchaseTips: '자동으로 갱신하면 언제든지 취소 가능합니다.',
  tips: '추가 정보:',
  promoCodeInvalidTips: '할인 코드가 잘못되었습니다.',
};
